const CrossAppActions = {
    SELECT_STEREOTYPE: "search-form/select-stereotype",
    SEARCH: "cross-app/search",
    SEARCH_RESULT: "cross-app/search-result",
    SEARCH_ERROR: "cross-app/search-error",
};

export default CrossAppActions;



// WEBPACK FOOTER //
// ./app/data/CrossAppActions.js